import { IImpact } from "@/pages/dashboard/utils/types";

export function multiplyImpactWithFactor(impact?: IImpact, factor?: number | undefined | null) {
  if (!factor || !impact) return undefined;

  return Object.fromEntries(
    Object.keys(impact).map((x) => [x, impact[x as keyof typeof impact] * factor])
  ) as IImpact;
}
